/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pricerangeslider_Pricerange3Inputs */

const id_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rentang Harga`)
};

const ms_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julat Harga`)
};

const da_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisinterval`)
};

const de_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisspanne`)
};

const en_us2_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Range`)
};

const es_es2_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango de precios`)
};

const es_mx2_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango de precios`)
};

const fil_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saklaw ng Presyo`)
};

const fr_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plage de prix`)
};

const it_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervallo di prezzo`)
};

const hu_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ár tartomány`)
};

const nl_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijsbereik`)
};

const no_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisområde`)
};

const pl_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakres cen`)
};

const pt_br2_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Range`)
};

const pt_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo de preços`)
};

const ro_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval de preț`)
};

const fi_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinta-alue`)
};

const sv_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisintervall`)
};

const vi_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phạm vi giá`)
};

const tr_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat Aralığı`)
};

const cs_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cenové rozpětí`)
};

const bg_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ценови диапазон`)
};

const ru_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диапазон цен`)
};

const uk_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Діапазон цін`)
};

const ar_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاق السعر`)
};

const hi_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य सीमा`)
};

const th_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงราคา`)
};

const ja_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格帯`)
};

const zh_cn2_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Range`)
};

const zh_hant1_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Range`)
};

const ko_ui_pricerangeslider_pricerange3 = /** @type {(inputs: Ui_Pricerangeslider_Pricerange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Range`)
};

/**
* | output |
* | --- |
* | "Price Range" |
*
* @param {Ui_Pricerangeslider_Pricerange3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_pricerangeslider_pricerange3 = /** @type {((inputs?: Ui_Pricerangeslider_Pricerange3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pricerangeslider_Pricerange3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "ms") return ms_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "da") return da_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "de") return de_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "en-US") return en_us2_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "es-ES") return es_es2_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "es-MX") return es_mx2_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "fil") return fil_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "fr") return fr_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "it") return it_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "hu") return hu_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "nl") return nl_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "no") return no_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "pl") return pl_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "pt-BR") return pt_br2_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "pt") return pt_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "ro") return ro_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "fi") return fi_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "sv") return sv_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "vi") return vi_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "tr") return tr_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "cs") return cs_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "bg") return bg_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "ru") return ru_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "uk") return uk_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "ar") return ar_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "hi") return hi_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "th") return th_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "ja") return ja_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_pricerangeslider_pricerange3(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_pricerangeslider_pricerange3(inputs)
	return ko_ui_pricerangeslider_pricerange3(inputs)
});
export { ui_pricerangeslider_pricerange3 as "ui.priceRangeSlider.priceRange" }